import { sagaRoot } from "./root";
import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  APPOINTMENT_CREATE,
  APPOINTMENT_UPDATE,
  BRANDS,
  EVALUATION_CREATE,
  OFFICE_TIMING,
  CAR_DETAIL_UPDATE,
  CAR_REPORT_DETAIL,
  CAR_REPORT,
  CAR_REG_NUMBER,
  USER_UPDATE,
  TOASTER_SHOW,
  toaster_s,
} from "../constant";
import { syncCreditsAfterCharge } from "./syncCredits";
import { extractAppointmentRecord } from "../utils/appointmentBooking";
// get all cars brands
export function* getBrands(payload) {
  const response = yield call(sagaRoot, payload);
}
// get office timings
export function* getOfficetiming(payload) {
  const response = yield call(sagaRoot, payload);
}
//
export function* evaluationCreate(payload) {
  const response = yield call(sagaRoot, payload);
  if (response?.message?.type === "success") {
    yield call(syncCreditsAfterCharge);
  }
}
//
export function* appointmentCreate(payload) {
  const requestData = payload?.payload?.data || {};
  const response = yield call(sagaRoot, payload);
  yield put({ type: `${payload.payload.type}_UPDATE`, payload: response });
  const appointmentRecord = extractAppointmentRecord(
    response?.data ?? response
  );
  const messageType = response?.message?.type;
  const looksSuccessful =
    messageType === "success" ||
    messageType === toaster_s ||
    Boolean(appointmentRecord?.id);

  if (looksSuccessful && messageType !== "error") {
    const stored = appointmentRecord || {
      id: `booked-${Date.now()}`,
      evaluation: requestData.evaluation,
    };
    yield put({
      type: `${APPOINTMENT_CREATE}_SUCCESS`,
      payload: {
        ...stored,
        evaluation: stored.evaluation ?? requestData.evaluation,
      },
    });
    yield put({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        type: toaster_s,
        heading: "Appointment booked",
        description:
          "Your inspection appointment is confirmed. Continue on Car Steps.",
      },
    });
    yield call(syncCreditsAfterCharge);
  }
}
export function* appointmentUpdate(payload) {
  const response = yield call(sagaRoot, payload);
  if (response?.message?.type === "success") {
    yield put({ type: `${payload.payload.type}_UPDATE`, payload: response });
    yield call(syncCreditsAfterCharge);
  }
}
export function* carDetailUpdateSaga(payload) {
  const response = yield call(sagaRoot, payload);
}
export function* CarReportSaga(payload) {
  const response = yield call(sagaRoot, payload);
}
export function* CarReportDetailSaga(payload) {
  const response = yield call(sagaRoot, payload);
}
export function* userDetailSaga(payload) {
  const response = yield call(sagaRoot, payload);
}



export function* CarRegNumber(payload) {
  const response = yield call(sagaRoot, payload);
}

// saga watcher
export default function* authWatcher() {
  yield takeLatest(BRANDS, getBrands);
  yield takeLatest(OFFICE_TIMING, getOfficetiming);
  yield takeLatest(EVALUATION_CREATE, evaluationCreate);
  yield takeLatest(APPOINTMENT_CREATE, appointmentCreate);
  yield takeLatest(APPOINTMENT_UPDATE, appointmentUpdate);
  yield takeLatest(CAR_DETAIL_UPDATE, carDetailUpdateSaga);
  yield takeLatest(CAR_REPORT,  CarReportSaga);
  yield takeLatest(CAR_REPORT_DETAIL, CarReportDetailSaga);
  yield takeLatest(USER_UPDATE, userDetailSaga);
  yield takeLatest(CAR_REG_NUMBER, CarRegNumber);
}
